import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditNoteRes } from "./helper";

export const editNote = async (params: { id: number; data: NoteReqT }) =>
  axios.put(Routes.EDIT_NOTE + "/" + params.id, { ...params.data });

export const useEditNote = () =>
  useMutation({
    mutationKey: [Keys.EDIT_NOTE_MUT],
    mutationFn: editNote,
    onSuccess: onEditNoteRes,
  });
